import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
// import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import moment from "moment";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import XCloseIcon from "../../../../component/icons/x-close";
import Chip from "../../../../component/ui/chip";
import Tooltip from "../../../../component/ui/tooltip";
import { useLocation } from "react-router";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFilterReturn,
  TableFooter,
  TableHead,
  TableHeaderWrap,
  TableRow,
  TableSort,
} from "../../../../component/table/table-layout";
import { PlusIcon } from "lucide-react";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import RefundForm from "../../refundForm";
import StatusChip from "../../../../component/ui/chip/status";
import RefundQuickView from "./popup";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import { GlobalContext } from "../../../../context/Context";
import { Brand, ByClient, ByDate, Email, Merchant, Order, Person, Processor, Product, Refund, Source } from "../../../../component/icons/filter-icon";
import { TitleHeading } from "../../../../component/ui/layout";
import UpperTabs from "../../../../component/ui/table/short-filters";

const OrgRefunds = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [changeModal, setChangeModal] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [currentStatus, setCurrentStatus] = useState("");
  const [tableHeader, setTableHeader] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(10);

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [showRefund, setShowRefund] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const [sortFields, setSortFields] = useState([]);
  const [selectFilterName, setSelectFilterName] = useState("My Filter");
  const [editingFilters, setEditingFilters] = useState(null);

  let { state, dispatch } = useContext(GlobalContext);

  const [refundPopup, setRefundPopup] = useState(false);
  const [refundData, setRefundData] = useState([]);
  const [refundPopupHead, setRefundPopupHead] = useState({});

  const [filterDates, setFiltersDates] = useState({});
  const [tableFooter, setTableFooter] = useState([]);
  const [tabs, setTabs] = useState([]);
  // const [isFirstLoaded, setIsFirstLoaded] = useState(false);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    // Initialize filters from URL
    const initialFilters = initializeFiltersFromUrl();

    // Fetch data with initial filters
    filterData({ filters: initialFilters, page: 1 });
  }, []);

  const handleSingleSort = (field) => {
    setPageCount(1);
    setSortFields((prev) => {
      let currentSort = prev[0]; // Assume prev is an array with max 1 object
      let newSortField;
      if (currentSort && currentSort.field === field) {
        if (currentSort.order === "desc") {
          newSortField = { field, order: "asc" };
        } else if (currentSort.order === "asc") {
          newSortField = null;
        }
      } else {
        newSortField = { field, order: "desc" };
      }
      const finalSortFields = newSortField ? [newSortField] : [];
      // Trigger the filter with the updated sort
      filterData({ sortField: finalSortFields, page: 1 });
      return finalSortFields;
    });
  };

  const filterData = ({
    filters = filterReturn,
    page = pageCount,
    page_quantity = pageItemsCount,
    sortField = sortFields,
    btnCall = false,
  }) => {
    const sort_by = sortField[0]?.field || null;
    const sort_direction = sortField[0]?.order || null;
    const data = {
      page,
      page_quantity,
      filters,
      sort_by,
      sort_direction,
      btnCall,
    };
    getData(data);
  };

  const getData = async (data = null) => {
    if (data?.btnCall) {
      setBtnLoader(true);
    } else {
      setIsLoading(true);
    }
    let urlData = ``;
    if (data) {
      // urlData = !data?.page
      //   ? `?page_quantity=10&page=1`
      //   : `?page=${data?.page}${data?.page_quantity !== "all"
      //     ? `&page_quantity=${data?.page_quantity}`
      //     : ""
      //   }`;
      urlData = "?p=1";

      if (data?.filters) {
        data?.filters.forEach((el) => {
          const key = el.field || el.name; // support both
          if (el.selectedOpt === "is" && el.name == "daterange") {
            urlData += `&range=${el.value}`;
          } else if (el?.value !== "" && el?.value != null) {
            urlData += `&${key}=${el.value}`;
          }
        });
      }
      if (data?.sort_by && data?.sort_direction) {
        urlData += `&sort_by=${data.sort_by}&sort_direction=${data.sort_direction}`;
      }
    }

    try {
      let res = await apiCall({
        url: `refund-trackers/get-refund-track${urlData}`,
        method: "get",
      });
      if (data?.btnCall) {
        setBtnLoader(false);
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }
      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setTableFooter(res?.footer);
      setTabs(res?.shortcut_filters)
      setFiltersDates({
        start_date: res?.start_date,
        end_date: res?.end_date,
      });
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Err", error);
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setSelectedIds([]);
    getData({});
    setChangeModal(false);
    // setShowRefund(false);
    closePopup()
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const onStatusChange = (value) => {
    setCurrentStatus(value);
    setChangeModal(true);
  };

  const removeFilter = (fIndex) => {
    const updatedFilters = filterReturn.filter((_, index) => index !== fIndex);
    setFilterReturn(updatedFilters);
    setPageCount(1); // page reset
    filterData({ filters: updatedFilters, page: 1 });
  };

  let {
    agentList,
    cbOrRefundOptions,
    cbOutcomeOptions,
    departmentOptions,
    processorReasonOptions,
    qaStatusOptions,
    sourceOptions,
    workStatusOptions,
    brandoptions,
    merchantoptions,
    processoroptions,
    productoptions,
  } = state?.DropdownData || {};

  // console.log("State ", state?.DropdownData);

  const agentOptions = agentList?.map((agents) => ({
    value: agents.userid,
    label: agents.name,
  }));

  const filterModalData = [
    {
      name: "daterange",
      label: "By Date",
      options: ["between", "is"],
      selectedOpt: "between",
      value: "",
      isChecked: true,
      type: "dropdown",
      dropdown: [
        { label: "This Month", value: "this_month" },
        { label: "Last Month", value: "last_month" },
        { label: "This Year", value: "this_year" },
        { label: "Last Year", value: "last_year" },
        { label: "This Quarter", value: "this_quater" },
        { label: "All Time", value: "all_time" },

      ],
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
      Icon: ByDate
    },
    {
      name: "client_name",
      label: "By Client",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
      Icon: ByClient
    },
    {
      name: "order_id",
      label: "Order Id",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
      Icon: Order
    },
    {
      name: "email",
      label: "Email",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
      Icon: Email
    },
    {
      name: "brand_website",
      label: "Brand website",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: brandoptions ? brandoptions : [],
      dropdownKey: "label",
      dropdownVal: "value",
      Icon: Brand
    },
    {
      name: "merchant_name",
      label: "Merchant",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: merchantoptions ? merchantoptions : [],
      dropdownKey: "label",
      dropdownVal: "value",
      Icon: Merchant
    },
    {
      name: "processor",
      label: "Processor",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: processoroptions ? processoroptions : [],
      dropdownKey: "label",
      dropdownVal: "value",
      Icon: Processor
    },
    {
      name: "product_service",
      label: "Product",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: productoptions ? productoptions : [],
      dropdownKey: "label",
      dropdownVal: "value",
      Icon: Product
    },
    // {
    //   name: "work_status",
    //   label: "Work Status",
    //   options: ["is"],
    //   selectedOpt: "is",
    //   value: "",
    //   type: "dropdown",
    //   dropdown: workStatusOptions ? workStatusOptions : [],
    //   dropdownKey: "label",
    //   dropdownVal: "value",
    // },
    {
      name: "cb_or_refund",
      label: "Cb or Refund",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: cbOrRefundOptions ? cbOrRefundOptions : [],
      dropdownKey: "label",
      dropdownVal: "value",
      Icon: Refund
    },
    // {
    //   name: "cb_outcome",
    //   label: "Cb Outcome",
    //   options: ["is"],
    //   selectedOpt: "is",
    //   value: "",
    //   type: "dropdown",
    //   dropdown: cbOutcomeOptions ? cbOutcomeOptions : [],
    //   dropdownKey: "label",
    //   dropdownVal: "value",
    // },
    {
      name: "source",
      label: "Source",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: sourceOptions ? sourceOptions : [],
      dropdownKey: "label",
      dropdownVal: "value",
      Icon: Source
    },
    // {
    //   name: "account_manager",
    //   label: "Account Manager",
    //   options: ["is"],
    //   selectedOpt: "is",
    //   value: "",
    //   type: "dropdown",
    //   dropdown: agentOptions,
    //   dropdownKey: "label",
    //   dropdownVal: "value",
    // },
    // {
    //   name: "processor_reason_code",
    //   label: "Processor reason code",
    //   options: ["is"],
    //   selectedOpt: "is",
    //   type: "dropdown",
    //   dropdown: processorReasonOptions ? processorReasonOptions : [],
    //   dropdownKey: "label",
    //   dropdownVal: "value",
    // },
    // {
    //   name: "qa_status",
    //   label: "Qa status",
    //   options: ["is"],
    //   selectedOpt: "is",
    //   type: "dropdown",
    //   dropdown: qaStatusOptions ? qaStatusOptions : [],
    //   dropdownKey: "label",
    //   dropdownVal: "value",
    // },
    // {
    //   name: "dept_responsible",
    //   label: "Dept Responsible",
    //   options: ["is"],
    //   selectedOpt: "is",
    //   value: "",
    //   type: "dropdown",
    //   dropdown: departmentOptions ? departmentOptions : [],
    //   dropdownKey: "label",
    //   dropdownVal: "value",
    // },
    // {
    //   name: "business_unit",
    //   label: "Business Unit",
    //   options: ["is"],
    //   selectedOpt: "is",
    //   value: "",
    //   type: "dropdown",
    //   dropdown: agentOptions,
    //   dropdownKey: "label",
    //   dropdownVal: "value",
    // },
    // {
    //   name: "reporting_authority",
    //   label: "Reporting Authority",
    //   options: ["is"],
    //   selectedOpt: "is",
    //   value: "",
    //   type: "dropdown",
    //   dropdown: agentOptions,
    //   dropdownKey: "label",
    //   dropdownVal: "value",
    // },
    // {
    //   name: "team_lead_1",
    //   label: "Team Lead 1",
    //   options: ["is"],
    //   selectedOpt: "is",
    //   value: "",
    //   type: "dropdown",
    //   dropdown: agentOptions,
    //   dropdownKey: "label",
    //   dropdownVal: "value",
    // },
    // {
    //   name: "team_lead_2",
    //   label: "Team Lead 2",
    //   options: ["is"],
    //   selectedOpt: "is",
    //   value: "",
    //   type: "dropdown",
    //   dropdown: agentOptions,
    //   dropdownKey: "label",
    //   dropdownVal: "value",
    // },
    {
      name: "responsible_person",
      label: "Responsible Person",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: agentOptions,
      dropdownKey: "label",
      dropdownVal: "value",
      Icon: Person
    },
  ];

  // console.log("filterModalData", filterModalData)

  const editRefund = (ele) => {
    setCurrentData(ele);
    setShowRefund(true);
  };

  const tableRef = useRef(null);

  const getVisibleRowData = (eachList) => {
    return tableHeader
      ?.filter((eachHead) => eachHead.is_visible === 1 && eachHead.show === 1)
      .reduce((acc, eachHead) => {
        acc[eachHead.key] = eachList[eachHead.key];
        return acc;
      }, {});
  };

  const hasDateFilter = filterReturn?.some(
    (eachFilter) =>
      eachFilter?.name === "daterange" ||
      eachFilter?.name === "range"
  );


  const filtersToShow = hasDateFilter
    ? filterReturn
    : filterReturn?.filter((eachFilter) => eachFilter?.name !== "daterange" || eachFilter?.name !== "range");


  const location = useLocation();

  const initializeFiltersFromUrl = () => {
    const queryParams = new URLSearchParams(location.search);
    const typeFromUrl = queryParams.get("type");
    const dateRangeFromUrl = queryParams.get("date_range");

    let start_date = null;
    let end_date = null;

    const initialFilters = [];

    // Date Range
    if (dateRangeFromUrl) {
      [start_date, end_date] = dateRangeFromUrl.split(",");

      setFiltersDates({ start_date, end_date });

      // if (dateFilterTemplate) {
      //   const dateFilter = {
      //     ...dateFilterTemplate,
      //     name: "daterange",
      //     value: dateRangeFromUrl,



      //   };

      //   // Check if already exists in filterReturn
      //   setFilterReturn((prev) => {
      //     const exists = prev.find((f) => f.name === "daterange");
      //     if (exists) {
      //       // Update existing
      //       return prev.map((f) =>
      //         f.name === "daterange" ? dateFilter : f
      //       );
      //     } else {
      //       // Add new
      //       return [...prev, dateFilter];
      //     }
      //   });

      //   initialFilters.push(dateFilter);
      // }

      const dateFilterTemplate = filterModalData.find(
        (f) => f.name === "daterange"
      );

      if (dateFilterTemplate) {
        let value = dateRangeFromUrl;

        if (dateRangeFromUrl && dateRangeFromUrl.includes(",")) {
          value = dateRangeFromUrl.split(",");
        }

        const daterangeFilter = {
          ...dateFilterTemplate,
          selectedOpt: "between",
          value: value
        };

        setFilterReturn(prev => {
          const index = prev.findIndex(f => f.name === daterangeFilter.name);
          if (index !== -1) {
            const newArr = [...prev];
            newArr[index] = daterangeFilter;
            return newArr;
          } else {
            return [...prev, daterangeFilter];
          }
        });

        initialFilters.push(daterangeFilter);
      }
    }

    // cb_or_refund / type
    if (typeFromUrl) {
      const typeFilterTemplate = filterModalData.find(
        (f) => f.name === "cb_or_refund"
      );
      if (typeFilterTemplate) {

        const typeFilter = { ...typeFilterTemplate, value: typeFromUrl };

        setFilterReturn((prev) => {
          const index = prev.findIndex(f => f.name === typeFilter.name);
          // if (index !== -1) {
          //   return prev.map((f) =>
          //     f.name === "cb_or_refund" ? typeFilter : f
          //   );
          // } else {
          //   return [...prev, typeFilter];
          // }

          if (index !== -1) {
            const newArr = [...prev];
            newArr[index] = typeFilter;
            return newArr;
          } else {
            return [...prev, typeFilter];
          }
        });

        initialFilters.push(typeFilter);
      }
    }

    return initialFilters;
  };

  const getFilterDisplayValue = (filter) => {

    if (
      filter?.type === "dropdown" &&
      filter?.dropdown?.length &&
      filter?.value !== "" &&
      filter?.value != null &&
      filter?.selectedOpt != "between"
    ) {
      const found = filter.dropdown.find(
        (opt) =>
          String(opt[filter.dropdownVal]) === String(filter.value)
      );

      return found
        ? found[filter.dropdownKey]
        : filter.value;
    }

    // multi-select case (array)
    console.log("Second Condition", Array.isArray(filter?.value));
    console.log("filter?.value", filter?.value)
    if (Array.isArray(filter?.value)) {
      return filter.value
        .map((val) => {
          const found = filter.dropdown.find(
            (opt) =>
              String(opt[filter.dropdownVal]) === String(val)
          );
          return found ? found[filter.dropdownKey] : val;
        })
        .join(" & ");
    }

    if (filter?.value?.includes(",")) {
      return filter.value?.split(",")
        .map((val) => {
          const found = filter.dropdown.find(
            (opt) =>
              String(opt[filter.dropdownVal]) === String(val)
          );
          return found ? found[filter.dropdownKey] : val;
        })
        .join(" & ");
    }

    // normal text/date/etc
    return filter.value;
  };

  const closePopup = () => {
    setShowRefund(false);
    setCurrentData({});
    localStorage.removeItem("refundFormPrefilled")
  }

  const [activeTab, setActiveTab] = useState(null);

  const changeFilter = (val, eachTab) => {

    if (eachTab?.type == "api_call") {
      setapiApiFilter(true);
      let isMatched = false;
      const updatedFilter = filterModalData
        ?.map((eachFilter) => {
          if (eachFilter?.name == eachTab?.header_key) {
            isMatched = true;
            return {
              ...eachFilter,
              isChecked: true,
              value: eachTab?.filter_val,
            };
          } else {
            if (eachFilter?.isChecked) {
              return eachFilter;
            } else {
              return false;
            }
          }
        })
        ?.filter(Boolean);
      if (isMatched) {
        setFilterReturn(updatedFilter);
        getData({ filters: updatedFilter });
      } else {
        getData({
          filters: [
            ...updatedFilter,
            {
              name: eachTab?.header_key,
              isChecked: true,
              value: eachTab?.filter_val,
            },
          ],
        });
      }
    } else {
      setapiApiFilter(false);
    }
    setActiveTab(val);
  };

  const filteredData = useMemo(() => {
    if (!activeTab) return apiData;

    return apiData?.filter((eachData) => {
      const fieldValue = eachData?.[activeTab?.header_key];
      const filterValue = activeTab.value;

      if (Array.isArray(fieldValue)) {
        return fieldValue.includes(activeTab?.value);
      }

      if (typeof fieldValue === "string" && fieldValue.includes(",")) {
        return fieldValue
          .split(",")
          .map((item) => item.trim())
          .includes(filterValue);
      }

      return fieldValue === activeTab?.value;
    });
  }, [activeTab, apiData]);


  const [apiApiFilter, setapiApiFilter] = useState(false);

  const innerChange = (eachTab, i) => {
    if (eachTab?.type == "api_call") {
      setapiApiFilter(true);
      let isMatched = false;
      const updatedFilter = filterModalData
        ?.map((eachFilter) => {
          if (eachFilter?.name == eachTab?.header_key) {
            isMatched = true;
            return {
              ...eachFilter,
              isChecked: true,
              value: eachTab?.filter_val,
            };
          } else {
            if (eachFilter?.isChecked) {
              return eachFilter;
            } else {
              return false;
            }
          }
        })
        ?.filter(Boolean);
      if (isMatched) {
        setFilterReturn(updatedFilter);
        filterData({ filters: updatedFilter });
      } else {
        filterData({
          filters: [
            ...updatedFilter,
            {
              name: eachTab?.header_key,
              isChecked: true,
              value: eachTab?.filter_val,
            },
          ],
        });
      }
    } else {
      setapiApiFilter(false);
    }
    let allTabs = [...tabs];
    allTabs.splice(2, 0, eachTab);
    allTabs.splice(i + 1, 1);
    setTabs(allTabs);
    setActiveTab({ value: eachTab?.value, header_key: eachTab?.header_key });
  };

  return (
    <>
      <div className={`${Style.mainBody}`}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>

              {/* OLD FILTER */}
              {/* {((filterDates?.start_date && filterDates.start_date !== 0) ||
                (filterDates?.end_date && filterDates.end_date !== 0) ||
                filtersToShow?.length > 0) && (
                  <div className={Style.filterContainer}>
                    <p className={Style.searchText}>Search By</p>

                    {!hasDateFilter &&
                      (filterDates?.start_date || filterDates?.end_date) && (
                        <div className={Style.eachFilter}>
                          <p
                            onClick={() => {
                              setShowModalFilterTable(true);
                            }}
                          >
                            <span>Date Filter:</span>

                            {filterDates?.start_date && (
                              <em>
                                <span>{filterDates?.start_date}</span>
                              </em>
                            )}

                            {filterDates?.start_date && filterDates?.end_date && (
                              <span> & </span>
                            )}

                            {filterDates?.end_date && (
                              <em>
                                <span>{filterDates?.end_date}</span>
                              </em>
                            )}
                          </p>
                        </div>
                      )}

                    {filtersToShow?.length > 0 &&
                      filtersToShow.map((eachFilter, i) => (
                        <div className={Style.eachFilter} key={i}>
                          <p
                            onClick={() => {
                              setShowModalFilterTable(true);
                            }}
                          >
                            <span>
                              {eachFilter?.name
                                ?.replace("search_by_", "")
                                .replaceAll("_", " ")}{" "}
                              :{" "}
                            </span>

                            <b>{eachFilter?.selectedOperator}</b>

                            <em>
                              {getFilterDisplayValue(eachFilter)}
                            </em>
                          </p>

                          <span
                            className={Style.searchClosedBtn}
                            onClick={() => removeFilter(i)}
                          >
                            <div className={Style.icon}>
                              <XCloseIcon />
                            </div>
                          </span>
                        </div>
                      ))}
                  </div>
                )} */}
              {console.log("filterReturn", filterReturn)}
              {console.log("filterModalData", filterModalData)}

              <TableFilterReturn
                filterReturn={(!filterReturn?.find(eachFilter => eachFilter?.name == "daterange")?.value?.length) ?
                  [
                    {
                      "name": "daterange",
                      "label": "Date Range",
                      "type": "date",
                      "selectedOpt": "between",
                      "value": [filterDates?.start_date, filterDates?.end_date],
                      "isCrossDisable": true
                    },
                    ...filterReturn
                  ]
                  : filterReturn
                }
                onChange={(filters) => {
                  // console.log("filtersfiltersfilters", filters)
                  setFilterReturn(filters);
                  getData({ filter: filters });
                }}
              />

              {/* HEADER */}
              {/* <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  <div>
                    <h1 className="text-xl font-bold pl-3 flex items-center gap-1">
                      Refund List
                    </h1>
                  </div>

                </div>

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>

                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                          }`}
                        onClick={() => {
                          setShowModalFilterTable(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn}`}
                        onClick={() => {
                          setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>

                    <div className={`
                      bg-[linear-gradient(92deg,#0057FB_1.54%,#003495_114.12%)] 
                      hover:bg-[linear-gradient(92deg,#0066FF_1.54%,#0045AA_114.12%)]
                      
                      py-[10px] px-[12px] rounded-[5px] text-center 
                      text-[#fff] text-[12px] font-semibold text-nowrap 
                      flex items-center justify-center transition-all
                      gap-1
                      cursor-pointer
                    `}
                      onClick={() => {
                        setShowRefund(true);
                      }}
                    >
                      <PlusIcon size={"1em"} />
                      Add Refund
                    </div>
                  </div>
                </div>
              </div> */}

              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  <div className="flex flex-col gap-1">
                    <TitleHeading title={"Refund List"} className={"!pl-0"} />
                    <h3 className="text-gray-500 text-[14px]"> Total Refund</h3>
                  </div>
                </div>

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>

                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                          }`}
                        onClick={() => {
                          setShowModalFilterTable(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn}`}
                        onClick={() => {
                          setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>

                    <div className={`
                      bg-[linear-gradient(92deg,#0057FB_1.54%,#003495_114.12%)] 
                      hover:bg-[linear-gradient(92deg,#0066FF_1.54%,#0045AA_114.12%)]
                      
                      py-[10px] px-[12px] rounded-[5px] text-center 
                      text-[#fff] text-[12px] font-semibold text-nowrap 
                      flex items-center justify-center transition-all
                      gap-1
                      cursor-pointer
                    `}
                      onClick={() => {
                        setShowRefund(true);
                      }}
                    >
                      <PlusIcon size={"1em"} />
                      Add Refund
                    </div>
                  </div>
                </div>
              </div>

              {/* {(tabs?.length && !isLoading) ?
                <UpperTabs
                  activeTab={activeTab}
                  setActiveTab={changeFilter}
                  upparTabs={tabs?.length ? tabs : upparTabs?.length ? upparTabs : []}
                  // totalEmp={totalEmp}
                  userData={userData}
                  DepartmentIcons={upperCustomIcon || DepartmentIcons}
                  onInnerChange={innerChange}
                  isAllFilterShow={isAllFilterShow}
                  upparTabsLimite={upparTabsLimite}
                  UpparAllIcon={UpparAllIcon}
                />
                :
                null
              } */}
              {apiData.length > 0 && !isLoading ? (
                <UpperTabs
                  activeTab={activeTab}
                  setActiveTab={changeFilter}
                  upparTabs={tabs?.length ? tabs : []}
                  totalEmp={apiData?.length}
                  userData={apiData}
                  // DepartmentIcons={leadUpperTabIcons}
                  onInnerChange={innerChange}
                  isAllFilterShow={true}
                  upparTabsLimite={5}
                  UpparAllIcon={null}
                />
              ) : null}

              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <DataNotFound title={"Refund"} />
                ) : (
                  <>
                    <TableCard ref={tableRef}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell className={"min-w-[220px] max-w-[220px]"} header sticky>
                              {/* <div className="flex gap-4 items-center">
                                <span>User Details</span>
                              </div> */}
                              <TableHeaderWrap>
                                <span>Client</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell className={"!left-[220px]"} header sticky>
                              <TableHeaderWrap>
                                <span>Total Loss</span>
                              </TableHeaderWrap>
                            </TableCell>

                            {tableHeader?.map((eachHead, index) =>
                              eachHead.is_visible === 1 &&
                                eachHead?.show == 1 ? (
                                <TableCell header key={index}>
                                  <TableHeaderWrap>
                                    <span>{eachHead?.value}</span>
                                    {eachHead?.sort_by ? (
                                      <TableSort
                                        field={eachHead?.key}
                                        sortFields={sortFields}
                                        onSort={handleSingleSort}
                                        Style={Style}
                                      />
                                    ) : (
                                      <TableSort
                                        disabled={true}
                                        field={eachHead?.key}
                                        Style={Style}
                                      />
                                    )}
                                  </TableHeaderWrap>
                                </TableCell>
                              ) : null
                            )}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {(apiApiFilter ? apiData : filteredData)?.map((eachList, index) => {
                            return (
                              <TableRow key={`${index}`}>
                                <TableCell sticky>
                                  {/* {eachList?.client_name ?? "-"} */}

                                  <div
                                    className={`${Style.tableActionArea} !gap-4`}
                                  >
                                    <div className="flex items-center gap-3">
                                      <div className="font-medium leading-5 whitespace-pre-wrap break-all">
                                        {eachList?.client_name ?? "-"}
                                      </div>
                                    </div>

                                    <div
                                      className={Style.tableActionAreaBtnGrpup}
                                    >
                                      <div
                                        className={
                                          "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                        }
                                        onClick={() => {
                                          editRefund(eachList);
                                        }}
                                      >
                                        <div
                                          className={Style.icon}
                                          style={{ color: "#FF9500" }}
                                        >
                                          <NewEditIcon className="h-4.5 w-4.5" />
                                        </div>
                                      </div>

                                      <div
                                        className={
                                          "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                        }
                                        onClick={() => {
                                          const visibleRowData =
                                            getVisibleRowData(eachList);
                                          setRefundPopup(true);
                                          setRefundData([visibleRowData]);
                                          setRefundPopupHead({
                                            client_name: eachList?.client_name,
                                            email: eachList?.email,
                                            cb_or_refund:
                                              eachList?.cb_or_refund,
                                            id: eachList?.id
                                          });
                                        }}
                                      >
                                        <div
                                          className={Style.icon}
                                          style={{ color: "#007AFF" }}
                                        >
                                          <NewEyeIcon className="h-4.5 w-4.5" />
                                        </div>
                                      </div>
                                      {/* <div
                                        className={
                                          "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                        }
                                      // onClick={() => {
                                      //   setEmpPopup(true);
                                      //   setEmpData(eachList);
                                      // }}
                                      >
                                        <div
                                          className={Style.icon}
                                          style={{ color: "#007AFF" }}
                                        >
                                          <NewEyeIcon className="h-4.5 w-4.5" />
                                        </div>
                                      </div> */}
                                    </div>
                                  </div>
                                </TableCell>

                                <TableCell className={"!left-[220px]"} sticky>
                                  {eachList?.net_loss ?? "-"}
                                </TableCell>


                                {tableHeader?.map((eachHead, i) =>
                                  eachHead.is_visible === 1 &&
                                    eachHead?.show == 1 ? (
                                    <TableCell
                                      key={`${i}-${index}`}
                                      isDim={eachHead?.dim_text === 1}
                                      className={
                                        eachHead?.key === "case_study" ||
                                          eachHead?.key === "qa_analysis"
                                          ? Style.truncate
                                          : ""
                                      }
                                      title={
                                        eachHead?.key === "case_study" ||
                                          eachHead?.key === "qa_analysis"
                                          ? eachList?.[eachHead?.key]
                                          : ""
                                      }
                                    >
                                      {/* cb_or_refund column */}
                                      {eachHead?.key === "cb_or_refund" ? (
                                        eachList[eachHead.key] === "Chargeback" ? (
                                          <StatusChip color="red">
                                            {eachList[eachHead.key] || "--"}
                                          </StatusChip>
                                        ) : eachList[eachHead.key] === "Refund" ? (
                                          <StatusChip color="yellow">
                                            {eachList[eachHead.key] || "--"}
                                          </StatusChip>
                                        ) : (
                                          <>
                                            {eachList[eachHead.key] || "--"}
                                          </>
                                        )
                                      ) : /* source column */
                                        eachHead?.key === "source" ? (
                                          eachList[
                                            eachHead.key
                                          ]?.toLowerCase() === "ppc" ? (
                                            <StatusChip color="red">
                                              PPC
                                            </StatusChip>
                                          ) : eachList[
                                            eachHead.key
                                          ]?.toLowerCase() === "upsell" ? (
                                            <StatusChip color="yellow">
                                              Upsell
                                            </StatusChip>
                                          ) : eachList[eachHead.key] ===
                                            "Google" ? (
                                            <StatusChip color="red">
                                              Google
                                            </StatusChip>
                                          ) : eachList[eachHead.key] ===
                                            "Bing" ? (
                                            <StatusChip color="blue">
                                              Bing
                                            </StatusChip>
                                          ) : eachList[eachHead.key] ===
                                            "Direct" ? (
                                            <StatusChip color="purple">
                                              Direct
                                            </StatusChip>
                                          ) : eachList[eachHead.key] ===
                                            "Support" ? (
                                            <StatusChip color="yellow">
                                              Support
                                            </StatusChip>
                                          ) : eachList[eachHead.key] ===
                                            "Refund Against Duplicate" ? (
                                            <StatusChip color="red">
                                              Refund Against Duplicate
                                            </StatusChip>
                                          ) : eachList[eachHead.key] ===
                                            "Email" ? (
                                            <StatusChip color="purple">
                                              Email
                                            </StatusChip>
                                          ) : eachList[eachHead.key] === "N/A" ? (
                                            <StatusChip color="yellow">
                                              N/A
                                            </StatusChip>
                                          ) : (
                                            <>
                                              {eachList[eachHead.key] || "--"}
                                            </>

                                          )
                                        ) : /* responsible column */
                                          eachHead?.key === "responsible" ? (
                                            eachList[eachHead.key] === "Sales" ? (
                                              <StatusChip color="green">
                                                Sales
                                              </StatusChip>
                                            ) : eachList[eachHead.key] ===
                                              "Customer" ? (
                                              <StatusChip color="yellow">
                                                Customer
                                              </StatusChip>
                                            ) : eachList[eachHead.key] ===
                                              "Content Management" ? (
                                              <StatusChip color="blue">
                                                Content Management
                                              </StatusChip>
                                            ) : eachList[eachHead.key] ===
                                              "SMM" ? (
                                              <StatusChip color="purple">
                                                SMM
                                              </StatusChip>
                                            ) : "Duplicate Charge" ? (
                                              <StatusChip color="red">
                                                Duplicate Charge
                                              </StatusChip>
                                            ) :
                                              "Production" ? (
                                                <StatusChip color="purple">
                                                  Production
                                                </StatusChip>
                                              ) :
                                                "Billing" ? (
                                                  <StatusChip color="purple">
                                                    Billing
                                                  </StatusChip>
                                                ) :
                                                  "Others" ? (
                                                    <StatusChip color="purple">
                                                      Others
                                                    </StatusChip>
                                                  ) :
                                                    "Procurement & Outsourcing" ? (
                                                      <StatusChip color="purple">
                                                        Procurement & Outsourcing
                                                      </StatusChip>
                                                    ) : (
                                                      eachList?.[eachHead?.key] ?? "-"
                                                    )
                                          ) : /* dept_responsible column */
                                            eachHead?.key === "dept_responsible" ? (
                                              ["Customer", "Sales"].includes(
                                                eachList[eachHead.key]
                                              ) ? (
                                                <StatusChip color="yellow">
                                                  {eachList[eachHead.key]}
                                                </StatusChip>
                                              ) : ["Design", "Development"].includes(
                                                eachList[eachHead.key]
                                              ) ? (
                                                <StatusChip color="blue">
                                                  {eachList[eachHead.key]}
                                                </StatusChip>
                                              ) : ["qa"].includes(
                                                eachList[eachHead.key]
                                              ) ? (
                                                <StatusChip color="purple">
                                                  {eachList[eachHead.key]}
                                                </StatusChip>
                                              ) : [
                                                "Account Management",
                                                "Operations",
                                              ].includes(eachList[eachHead.key]) ? (
                                                <StatusChip color="green">
                                                  {eachList[eachHead.key]}
                                                </StatusChip>
                                              ) : ["Support"].includes(
                                                eachList[eachHead.key]
                                              ) ? (
                                                <StatusChip color="yellow">
                                                  {eachList[eachHead.key]}
                                                </StatusChip>
                                              ) : ["Client (Not Our Fault)"].includes(
                                                eachList[eachHead.key]
                                              ) ? (
                                                <StatusChip color="red">
                                                  {eachList[eachHead.key]}
                                                </StatusChip>
                                              ) : (
                                                eachList?.[eachHead?.key] ?? "-"
                                              )
                                            ) : (
                                              /* other columns */
                                              eachList?.[eachHead?.key] ?? "-"
                                            )}
                                    </TableCell>
                                  ) : null
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>

                        <TableFooter>
                          <TableRow>
                            <TableCell
                              sticky
                              header
                              className="text-gray-800 font-bold tracking-wide uppercase"
                            >
                              Summary
                            </TableCell>

                            <TableCell
                              sticky
                              header
                              className={"!left-[220px]"}
                            // font-number
                            >
                              {tableFooter?.net_loss ?? "--"}
                            </TableCell>

                            {tableHeader.map((h_ele, h_idx) =>
                              h_ele.is_visible === 1 && h_ele?.show == 1 ? (
                                <TableCell
                                  header
                                  key={`tf-${h_idx}`}
                                  className={`${h_ele?.type === "number"
                                    ? "!text-end font-number"
                                    : ""
                                    } ${h_ele?.key === "credit"
                                      ? "!text-green-600 font-semibold"
                                      : h_ele?.key === "debit"
                                        ? "!text-red-600 font-semibold"
                                        : ""
                                    }`}
                                >
                                  {tableFooter[h_ele?.key] ?? "--"}
                                </TableCell>
                              ) : null
                            )}
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableCard>
                  </>
                )}
              </div>

              {/* {!isLoading ? (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    {`showing 1 to ${apiData?.length} of ${tablePagination?.total || apiData?.length
                      }`}
                  </div>

                  {tablePagination ? (
                    <div className={Style.empDirectory_footer}>
                      {tablePagination?.next_page_url ? (
                        <button
                          className={Style.loadMoreBtn}
                          onClick={() => {
                            if (btnLoader) return;
                            // setPageCount(pageCount + 1);
                            setBtnLoader(true);
                            // filterData({ page: pageCount + 1, btnCall: true });
                            filterData({
                              btnCall: true,
                              page: tablePagination?.next_page_url,
                            });
                          }}
                        >
                          {btnLoader ? (
                            <InnerLoader
                              className={Style.loader}
                              textStatus={false}
                            />
                          ) : (
                            "Load More"
                          )}
                        </button>
                      ) : null}
                    </div>
                  ) : null}

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              ) : (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    <Skeleton width={"50%"} height={15} />
                  </div>

                  <div className={Style.empDirectory_footer}>
                    <Skeleton width={"180px"} height={40} />
                  </div>

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          // onSave={(filters, filterName, editingFilter) => {
          //   getData({ filter: filters });
          //   setShowModalFilterTable(false);
          //   setFilterReturn(filters);
          // }}
          saveFilter={saveFilter}
          apiUrl="get-refund-track"
          onSave={(filters, filterName, editingFilter) => {
            setShowModalFilterTable(false);
            setFilterReturn(filters ? filters : []);
            setSelectFilterName(filterName ? filterName : "My Filter");
            setEditingFilters(editingFilter ? editingFilter : []);
            setPageCount(1);
            filterData({ filters: filters, page: 1 });
          }}
          selectFilterName={selectFilterName}
          editingFilters={editingFilters}
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="get-refund-track"
        />
      )}

      {showRefund && (
        <RefundForm
          onError={onError}
          onSubmit={onSuccess}
          onClose={closePopup}
          refundDataId={currentData}
        />
      )}

      {/* {changeModal &&
        <ChangeHolidayStatus onClose={() => {setChangeModal(false); setCurrentStatus("")}} onSubmit={onSuccess} onError={onError} selectedList={selectedIds} selectedStatus={currentStatus} />
      } */}

      {/* {console.log("refundData", refundData)} */}

      {refundPopup && (
        <RefundQuickView
          onClose={() => {
            setRefundPopup(false);
            setRefundData([]);
            setRefundPopupHead({});
          }}
          refundData={refundData}
          refundPopupHead={refundPopupHead}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default OrgRefunds;
